import { useEffect } from "react";

export default function useSetDebouncedUrlParams(newUrlParams: URLSearchParams, delay: number = 300, hasData: boolean) {
  useEffect(() => {
    const handler: NodeJS.Timeout = setTimeout(() => {
      if(typeof window !== 'undefined' && hasData) {
        window.history.replaceState(Object.fromEntries(newUrlParams), '', `${window.location.pathname}?${newUrlParams.toString()}`);
      }

    }, delay);

    // Cancel the timeout if value changes (also on delay change or unmount)
    return () => {
      clearTimeout(handler);
    };
  }, [newUrlParams, delay]);

  return newUrlParams;
}
